const injectScript = (
  SCRIPT: string,
  callback = () => {},
  onError = () => {},
) => {
  const script = document.createElement('script');
  script.src = SCRIPT;
  script.onload = callback;
  script.onerror = onError;
  script.crossOrigin = '';

  document.body && document.body.appendChild(script);
};

export default injectScript;
